export const SourceType = Object.freeze({
    PACE: {
        key: "PACE",
        value: "PACE"
    },
    Manual: {
        key: "Manual",
        value: "Manual",
    },
    SpottOrder: {
        key: "SpottOrder",
        value: "Spott Order",
    },
    SFAMobile: {
        key: "SFAMobile",
        value: "SFA Mobile",
    }
})